// Static menu data sourced from the in-store pre-designed menu boards.
// Edit this file to update prices or items — the Menus page reads from here.

export const PRE_DESIGNED = {
  title: "Pre Designed Menu",
  footnote: "Check our specials board in store for limited-time options!",
  sections: [
    {
      id: "rolled-ice-creams",
      label: "Rolled Ice Creams",
      items: [
        {
          name: "Cookie Monster",
          price: 12.5,
          description:
            "Vanilla ice cream, Oreo mixing, chocolate mousse, chocolate hail, Oreo crumble, chocolate sauce & mini Oreo's.",
        },
        {
          name: "Snickerama",
          price: 12.5,
          description:
            "Caramel ice cream, flake & chopped nut mixing, chocolate sauce, caramel sauce, chopped nuts & mini Snickers bar.",
        },
        {
          name: "Gold Rush",
          price: 12.8,
          description:
            "Salted caramel ice cream, Crunchie mixing, chocolate sauce, fudge pieces & chocolate hail.",
        },
        {
          name: "The Nutjob",
          price: 12.2,
          description:
            "Vanilla ice cream, peanut butter mixing, chocolate mousse, chocolate sauce, Reese's Pieces & chopped nuts.",
        },
        {
          name: "Miss Piggy",
          price: 11.0,
          description:
            "Strawberry ice cream, whipped cream, sprinkles & mini marshmallows.",
        },
        {
          name: "Oreo Overload",
          price: 11.2,
          description:
            "Chocolate ice cream, 2x Oreo mixing, caramel sauce & Oreo crumble.",
        },
        {
          name: "Arctic Ice",
          price: 10.5,
          description:
            "Blue lagoon ice cream, whipped cream, sprinkles & M&M's.",
        },
        {
          name: "Jelly Roll",
          price: 11.5,
          description:
            "Raspberry ice cream, flake mixing, raspberry sherbet, chocolate sauce & chocolate hail.",
        },
      ],
    },
    {
      id: "waffles",
      label: "Waffles",
      items: [
        {
          name: "Choffle",
          price: 13.9,
          description:
            "Chocolate waffle, chocolate sauce, Nutella sauce, whipped cream & Oreo crumble.",
        },
        {
          name: "Cookie Crumble",
          price: 14.2,
          description:
            "Standard waffle, Oreo crumble, whipped cream, chocolate sauce, icing sugar & mini Oreo cookies.",
        },
      ],
    },
    {
      id: "pancakes",
      label: "Pancakes",
      items: [
        {
          name: "Monkey Business",
          price: 16.5,
          description:
            "Full pancake stack, whipped cream, fresh banana, Nutella & icing sugar.",
        },
        {
          name: "Sweet Caroline",
          price: 14.5,
          description:
            "Full pancake stack, whipped cream, sugar & cinnamon, maple syrup.",
        },
      ],
    },
  ],
};

export const DESSERTS_SHAKES = {
  title: "Other Desserts & Shakes",
  footnote: "Add soft serve $2.50 · Add whipped cream $1.00 · Extra sauce $1.00",
  sections: [
    {
      id: "cookie-pies",
      label: "Cookie Pies",
      flatPrice: 6.5,
      flatPriceLabel: "$6.50 each",
      items: [
        { name: "Nutella" },
        { name: "Biscoff" },
        { name: "M&M Nutella" },
        { name: "White Choc & Raspberry" },
        { name: "Banoffee" },
        { name: "Choc Caramel" },
        { name: "Bueno" },
      ],
    },
    {
      id: "cheesecakes",
      label: "Cheesecakes",
      flatPrice: 9.0,
      flatPriceLabel: "$9.00 each",
      items: [
        { name: "Biscoff" },
        { name: "Nutella" },
        { name: "Raspberry Brulee" },
        { name: "Creme Brulee" },
        { name: "Oreo" },
        { name: "Passionfruit" },
      ],
    },
    {
      id: "other-desserts",
      label: "Other Desserts",
      items: [
        {
          name: "Sticky Date Pudding",
          price: 10.5,
          description: "Sticky date pudding, heated with butterscotch sauce.",
        },
        {
          name: "Apple Crumble",
          price: 9.9,
          description: "Apple crumble, heated with your choice of sauce.",
        },
        {
          name: "Banoffee Pie",
          price: 9.9,
          description:
            "Our #1 seller. Decadent pastry, smooth caramelised banana filling, topped with cream, chocolate & caramel sauce.",
        },
        {
          name: "Pecan Pie",
          price: 9.9,
          description:
            "An American favourite! Decadent pastry, pecan-based filling topped with even more pecan.",
        },
        {
          name: "Chocolate Brownie (GF)",
          price: 9.5,
          description:
            "Chocolate brownie, heated with your choice of sauce (we suggest chocolate!).",
        },
        {
          name: "Banana Split",
          price: 10.9,
          description:
            "A split banana, soft serve ice cream, whipped cream, 2 sauces of your choice, chopped nuts & sprinkles.",
        },
        {
          name: "Ambrosia",
          price: 9.5,
        },
      ],
    },
    {
      id: "milkshakes",
      label: "Milkshakes",
      flatPrice: 7.9,
      flatPriceLabel: "$7.90 each",
      items: [
        { name: "Vanilla" },
        { name: "Banana" },
        { name: "Strawberry" },
        { name: "Chocolate" },
        { name: "Caramel" },
        { name: "Creaming Soda" },
        { name: "Lime" },
        { name: "Spearmint" },
      ],
    },
    {
      id: "supershakes",
      label: "Supershakes",
      note: "All include whipped cream.",
      items: [
        {
          name: "Flake",
          price: 11.0,
          description:
            "Chocolate milkshake mixed with flake, chocolate sauce & more flake!",
        },
        {
          name: "Biscoff",
          price: 11.0,
          description:
            "Vanilla shake mixed with Biscoff, Biscoff sauce & Biscoff crumble.",
        },
        {
          name: "Oreo",
          price: 11.0,
          description:
            "Vanilla shake mixed with Oreo, chocolate sauce & Oreo crumble.",
        },
      ],
    },
  ],
};
